module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1000.66a4314f.svg";